<template>
  <header class="header">
    <RouterLink to="/" class="logo">
      <app-svg
        :icon="props.isHomepage ? 'logo' : 'logo-dark'"
        width="110"
        height="46"
      />
    </RouterLink>
    <DownloadLink class="header__btn" />
  </header>
</template>

<script setup>
import { defineProps } from 'vue'
import DownloadLink from './DownloadLink.vue'

const props = defineProps({
  isHomepage: Boolean
})
</script>
